import { FC } from "react";

import { useSearchParams } from "next/navigation";

import { useIsEmbeddedModal, useEmbeddedModal } from "@/common/hooks/useEmbeddedModal";
import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormOverlayButton } from "@/forms-design-system/FormButton/FormOverlayButton";
import { Cross } from "@/icons/outlined";

export const CloseEmbedButton: FC = () => {
  const { t } = useTranslate();
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { isSmallScreen } = useMediaQuery();
  const isEmbeddedModal = useIsEmbeddedModal(query);
  const { postMessageClose } = useEmbeddedModal(isEmbeddedModal);

  if (!isEmbeddedModal || !isSmallScreen) {
    return null;
  }

  return (
    <FormOverlayButton
      iconButton
      startIcon={<Cross />}
      onClick={postMessageClose}
      aria-label={t("common", "close")}
      data-test="ticketing-toggle-locale"
      components={{
        startIcon: {
          size: isSmallScreen ? "medium" : "large",
        },
      }}
      sx={{
        width: { xs: 36, md: 40 },
        height: { xs: 36, md: 40 },
      }}
    />
  );
};
